import React from 'react';
import { useTranslation } from 'react-i18next';
import { AdsTitle, AdsTitleCount } from './styled';

interface AdsSectionTitleProps {
  isItemsAllPage: boolean;
  adsCount?: number | null;
}

export const AdsSectionTitle: React.FC<AdsSectionTitleProps> = ({
  isItemsAllPage,
  adsCount
}) => {
  const { t } = useTranslation();

  return (
    <AdsTitle tag="h3">
      {t(isItemsAllPage ? 'search.items_all_ads' : 'search.ads')}
      {typeof adsCount === 'number' && (
        <AdsTitleCount tag="body_1">({adsCount})</AdsTitleCount>
      )}
    </AdsTitle>
  );
};
